<template>
  <Slide
    v-bind="slides[0]"
    v-if="slides.length == 1"
    :textPosition="textPosition"
  />
  <b-carousel
    v-else-if="slides.length > 1"
    :id="id"
    v-model="slide"
    :interval="4000"
    indicators
    @sliding-start="onSlideDisplay"
  >
    <!-- Text slides with image -->
    <b-carousel-slide img-blank v-for="(slide, index) in slides" :key="index">
      <template slot="img">
        <Slide v-bind="slide" :textPosition="textPosition" />
      </template>
    </b-carousel-slide>
  </b-carousel>
</template>

<style lang="scss">
.carousel {
  .carousel-inner {
    height: 100%;
    .carousel-item-prev,
    .carousel-item-next,
    .carousel-item.active {
      display: flex;
      height: 100%;
    }
  }
}
</style>

<script>
import Slide from "../Slide/Slide";
export default {
  name: "Slider",

  components: {
    Slide,
  },

  data() {
    return {
      slide: 0,
    };
  },

  props: {
    id: {
      type: String,
      required: true,
    },
    slides: {
      type: Array,
      required: true,
    },
    textPosition: {
      validator: prop => typeof prop === "string" || prop === null,
    },
  },

  methods: {
    onSlideDisplay(slideIndex) {
      this.$emit("slideDisplay", this.slides[slideIndex]);
    },
  },

  mounted() {
    this.$emit("slideDisplay", this.slides[this.slide]);
  },
};
</script>
